export default __webpack_public_path__ + "static/media/white.dbc8360b.gif";